import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'OverlayComponents',
    props: {
        componentCount: { type: Number, default: 0 },
    },
});
